/**
 * @module Theme
 */

import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ChartType } from '@models/chart.model';
import { ThemeOptionType } from '@models/themeStudio.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-theme-option-datalabels-text-shadow-color-detail',
  templateUrl: './theme-option-datalabels-text-shadow-color-detail.component.html',
  styleUrls: ['./theme-option-datalabels-text-shadow-color-detail.component.css']
})
export class ThemeOptionDatalabelsTextShadowColorDetailComponent implements OnInit, OnDestroy {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() datalabelsIndex: number;
  @Input() type: ChartType;

  color = ItemColor('themes');
  opacity: number;
  textShadowColor: string;
  changedSeries$sub: Subscription;
  optionType: ThemeOptionType = 'datalabels_textShadowColor';

  constructor() {}

  ngOnInit() {
    this.setAttributes();

    this.changedSeries$sub = this.themeOptions.changedSeries$.subscribe({
      next:(option: ThemeOptionType) => {
        if(option === this.optionType) {
          this.setAttributes();
        }
      }
    });
  }

  ngOnDestroy() {
    this.changedSeries$sub.unsubscribe();
  }

  setAttributes() {
    this.textShadowColor = this.themeOptions.datalabels(this.datalabelsIndex, this.type).textShadowColor.toString().slice(0, 7);
    this.opacity = Math.round(parseInt(this.themeOptions.datalabels(this.datalabelsIndex, this.type).textShadowColor.toString().slice(7, 9), 16) * 100 / 255);
  }
  
  receiveValue(value: string) {
    this.textShadowColor = value;
    this.themeOptions.setDatalabels(this.optionType, value + Math.round(this.opacity * 255 / 100).toString(16), this.datalabelsIndex, [this.type]);
  }

  receiveOpacity(value: number) {
    this.opacity = value;
    if(this.opacity > 0) this.themeOptions.setDatalabels(this.optionType, this.textShadowColor + Math.round(value * 255 / 100).toString(16), this.datalabelsIndex, [this.type]);
    else this.themeOptions.setDatalabels(this.optionType, this.textShadowColor + '00', this.datalabelsIndex, [this.type]);
  }

}
